import { render } from "./IndexSS23.vue?vue&type=template&id=4bab452b&scoped=true"
import script from "./IndexSS23.vue?vue&type=script&lang=js"
export * from "./IndexSS23.vue?vue&type=script&lang=js"

import "./IndexSS23.vue?vue&type=style&index=0&id=4bab452b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bab452b"]])

export default __exports__